export enum Variant {
  NEUTRAL = 'neutral',
  PRIMARY = 'primary',
}

export enum Size {
  SMALL = 'small',
  BIG = 'big',
}
